/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";
import moment from "moment";
import { Label, Checkbox } from "rbx";
import { ORDER_VIEW_COLUMNS } from "../Orders/columns";
import TableCell from "../../../components/TableCell";

export const ELD_IMPORT_COLUMNS = [...ORDER_VIEW_COLUMNS];

export const generateELDColumns = ({
  selected,
  allSelected,
  onSelect,
  onSelectAll
}) => [
  {
    Header: (
      <div>
        <Label>
          <Checkbox
            checked={allSelected}
            onChange={() => onSelectAll(!allSelected)}
          />
        </Label>
      </div>
    ),
    id: "RecId",
    defaultCanSort: false,
    disableSortBy: true,
    Cell: ({ row }) => (
      <div>
        <Label>
          <Checkbox
            checked={selected.includes(row.original.RecId)}
            onChange={() => onSelect(row.original.RecId)}
          />
        </Label>
      </div>
    )
  },
  ...ORDER_VIEW_COLUMNS
];

export const generateOrderDispatchingColumns = () => [
  {
    Header: "Pickup Date",
    accessor: "PickupDate",
    id: "PickupDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null,
    sortType: (a, b) => {
      const aVal = moment(a.original.PickupDate).format("YYYY-MM-DD");
      const bVal = moment(b.original.PickupDate).format("YYYY-MM-DD");
      if (aVal > bVal) return 1;
      if (bVal > aVal) return -1;
      return 0;
    }
  },
  {
    Header: "Trip #",
    accessor: "Trip",
    id: "Trip"
  },
  {
    Header: "Order(s)",
    accessor: "Orders",
    id: "Orders",
    Cell: ({ cell }) => (
      <div>
        {cell.value.map(x => (
          <React.Fragment>
            <TableCell.Link
              to={`/dispatch/orders/${x.RecId}/summary`}
              value={`#${x.OrderNumber} `}
            />
            <br />
          </React.Fragment>
        ))}
      </div>
    )
  },
  {
    Header: "Driver Name",
    accessor: "PickupDriverLastName",
    id: "PickupDriverLastName",
    Cell: obj => {
      const item = obj.data[obj.row.id];
      return `${item.PickupDriverFirstName}, ${item.PickupDriverLastName}`;
    }
  },
  {
    Header: "Booking Code",
    accessor: "BookingCode",
    id: "BookingCode"
  },
  {
    Header: "Tractor",
    accessor: "PickupTractor",
    id: "PickupTractor"
  },
  {
    Header: "Trailer",
    accessor: "PickupTrailer",
    id: "PickupTrailer"
  },
  {
    Header: "Pickup ID",
    accessor: "Pickup_LocationId",
    id: "PickupLocationID"
  },
  {
    Header: "Pickup Location",
    accessor: "PickUp_LocationName",
    id: "PickupLocation"
  },
  {
    Header: "City",
    accessor: "PickUp_City",
    id: "PickUp_City"
  },
  {
    Header: "State",
    accessor: "PickUp_State",
    id: "PickUp_State"
  },
  {
    Header: "Delivery ID",
    accessor: "Del_LocationId",
    id: "DeliveryLocationID"
  },
  {
    Header: "Delivery Location",
    accessor: "Del_LocationName",
    id: "DeliveryLocation"
  },
  {
    Header: "City",
    accessor: "Del_City",
    id: "Del_City"
  },
  {
    Header: "State",
    accessor: "Del_State",
    id: "Del_State"
  }
];
